import { createContext, useContext } from "react"

const GoalWeightSettingsContext = createContext()
const useGoalWeightSettingsContext = () => useContext(GoalWeightSettingsContext)

export {useGoalWeightSettingsContext, GoalWeightSettingsContext}